import { OktaAuth } from '@okta/okta-auth-js';
import config from 'src/config';

const oktaAuth = new OktaAuth(config.oidc);

export default oktaAuth;
